import type { FC } from 'react';
import Content from '../Content';
import { DegradationProperties } from '../../../../../../core/domain/map';

type Props = {
    networkProperties: DegradationProperties | null;
};

const DegradationPopupOnHover: FC<Props> = ({ networkProperties }) => {
    if (!networkProperties) {
        return null;
    }

    return <Content properties={networkProperties} />;
};

export default DegradationPopupOnHover;
